import { render } from "./NewsBox.vue?vue&type=template&id=638d5c77"
import script from "./NewsBox.vue?vue&type=script&lang=ts"
export * from "./NewsBox.vue?vue&type=script&lang=ts"

import "./NewsBox.vue?vue&type=style&index=0&id=638d5c77&lang=scss"
script.render = render

export default script